"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.noop = function () {
  return undefined;
};

exports.requestAnimationFrame = function (callback) {
  // This method was mostly created for node testing.
  // JSDOM (used by Enzyme) doesn't support requestAnimationFrame.

  /* istanbul ignore next */
  return window.requestAnimationFrame ? window.requestAnimationFrame(callback) : callback();
};

exports.isNodeEnv = function () {
  return !!(typeof process !== 'undefined' && typeof process.title === 'string' && process.title.toLowerCase().indexOf('node') >= 0);
};